import * as React from 'react'
import { Link } from 'gatsby';
    import {
      Typography,
    } from "@mui/material";

const TextSmall = ({ content, color, className }) => {
  return (
    <Typography className='small-text' sx={{ 
      '&.MuiTypography-root': {
        display: 'inline',
        color: {color},
        className: {className}
      }
     }}>
    {content}
  </Typography>
  )
}

export default TextSmall